<template>
  <BaseSection bg="covid" is-wide>
    <template #header>
      <BaseTitle
        tag="h1"
        size="xl"
        is-medium
        data-animation="fadeIn"
        data-animation-delay="100"
        text="Ба-бах!"
      />
    </template>
    <template #content>
      <div class="section__row">
        <div class="section__col">
          <BaseText
            size="m"
            data-animation="fadeIn"
            data-animation-delay="300"
          >
            Внезапно начавшаяся пандемия COVID&#8209;19 не только поставила под вопрос готовность компаний оперативно адаптировать операционные процессы под новые условия, <b>но и&nbsp;показала бизнесу важность менее видимой, но очень важной составляющей – HR&#8209;бренда</b>
          </BaseText>
        </div>
        <div class="section__col section__col_banner">
          <div data-animation="fadeInTop" data-animation-delay="600">
            <BaseVideo file="virus.mp4" :autoplay="10" :controls="false" muted="muted" is-square is-loop is-round />
          </div>
        </div>
      </div>
      <div class="section__gap">
        <BaseText
          size="m"
          data-animation="fadeIn"
          data-animation-delay="900"
        >
          Вместе с HR&#8209;экспертами ведущих российских компаний мы выясним, какие проблемы стоят перед специалистами сегодня и&nbsp;как работать с&nbsp;ними для достижения лучшего результата
        </BaseText>
      </div>
    </template>
  </BaseSection>
</template>

<script>
import pageMixin from '@/mixins/page';
import BaseSection from '@/components/BaseSection.vue';
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseVideo from '@/components/BaseVideo.vue';

export default {
  name: 'CovidPage',
  mixins: [pageMixin],
  components: {
    BaseSection,
    BaseTitle,
    BaseText,
    BaseVideo,
  },
};
</script>
